import { Grid, Skeleton } from '@mui/material';
import { SkeletonList } from '../skeleton-list/SkeletonList';
import { footerStyles } from './styles';
import _ from 'lodash';

export const FooterLoadingComponent: React.FC = () => {
  return (
    <>
      <Grid container spacing={2.5} sx={footerStyles.socialSection}>
        <Grid item sx={footerStyles.socialIconContainer} xs="auto">
          <Skeleton variant="text" height="2rem" width="10rem" sx={{ mr: 4 }} />
          <SkeletonList variant="circular" sx={{ mr: 3 }} width="2rem" height="2rem" itemsCount={4} />
        </Grid>
        <Grid item xs={12} md={4} lg={3}>
          <Skeleton variant="rectangular" height={40} width="100%" />
        </Grid>
      </Grid>
      <Grid container sx={{ mt: 4 }} rowSpacing={4} columnSpacing={2.5}>
        {Array(4)
          .fill('')
          .map((_item, index) => (
            <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
              <Skeleton variant="text" height="2rem" width="15rem" sx={{ mb: 1 }} />
              <SkeletonList itemsCount={3} variant="text" height="1.75rem" width={`${_.random(8, 15, true)}rem`} />
            </Grid>
          ))}
      </Grid>
      <Grid container alignItems="center" sx={{ mt: 4 }} spacing={1}>
        <Grid item>
          <Grid container alignItems="center">
            <Skeleton variant="rectangular" width="15rem" height="3rem" />
            <Skeleton variant="text" width="10rem" height="2rem" sx={{ ml: 2 }} />
          </Grid>
        </Grid>
        <Grid item sx={{ ml: 'auto' }}>
          <Skeleton variant="text" width="5rem" height="2.5rem" />
        </Grid>
      </Grid>
    </>
  );
};
